// AUTO-GENERATED by scripts/build-docs-artifact.mjs — do not edit by hand.
// sha256 of content/docs/**. The CRM sends this with chat/search requests so
// crm-chat-api fetches the matching pre-built embeddings artifact from
// `${DOCS_ARTIFACT_BASE_URL}/<sha>/` (prod). Refresh via `pnpm docs:artifact`;
// CI keeps it in sync on PRs that touch content/docs.
// Pre-wrapped to match Prettier so the generated file stays format-stable.
export const DOCS_ARTIFACT_VERSION =
  'ff513b73b9536f6a1925769400d6b387393ef554d065922020ab012e721aa393';
